<template>
    <div class="m-portlet m-portlet--head-sm" v-loading="loading" v-if="powers.includes(54)">
        <div class="m-portlet__head" >
            <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                    <div class="m-portlet__head-text">
                        <div>
                            <el-row :gutter="30">
                                <el-col :span="4">
                                    <el-select v-model="filter.semester_type_id" placeholder="请选择" @change="handleSemesters">
                                        <el-option
                                                v-for="item in semester_types"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="4">
                                    <el-select v-model="filter.semester_id" placeholder="请选择" @change="handleShow">
                                        <el-option
                                                v-for="item in semesters"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="5">
                                    <small>结束日期：</small>
                                    <el-date-picker
                                            v-model="filter.date"
                                            type="date"
                                            clearable
                                            style="width: 150px"
                                            value-format="yyyy-MM-dd"
                                            placeholder="选择日期"
                                            @change="handleShow()">
                                    </el-date-picker>
                                </el-col>
                                <el-col :span="3">
                                    <el-select v-model="filter.grade_id" multiple clearable placeholder="请选择年级"
                                               @change="changeGrade">
                                        <el-option
                                                v-for="item in grades"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="2">
                                    <el-switch v-model="showStudent"
                                               @change="showStudentFuc"
                                               active-text="显示学生"
                                               size="small">
                                    </el-switch>
                                </el-col>
                                <el-col :span="2" v-if="disableType && powers.includes(112)">
                                    <el-switch v-model="crunkView"
                                               @change="handleViewCrunk"
                                               active-text="显示余课"
                                               size="small">
                                    </el-switch>
                                </el-col>
                                <el-col :span="2">
                                    <el-button @click="handleTableSite()" v-if="powers.includes(73)">设置</el-button>
                                </el-col>
                                <el-col :span="2">
                                    <el-button @click="handleExcel()" v-if="powers.includes(127)">导出Excel</el-button>
                                </el-col>
                            </el-row>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div class="m-portlet__body"
             :style="{'min-height':$store.state.config.clientHeight-96-53.2-32.5+'px'}">
            <V4Table v-if="V4Judge" ref="V4Table"
                     @handleMouseDown="handleMousedown"
                     @handleTeacherMouseDown="handleTeacherMouseDown"
                     @drop="drop"
                     @allowDrop="allowDrop">
            </V4Table>
        </div>
    </div>
</template>

<script>
    import index from './Index'
    import store from '@/store'
    export default {
        name: "OperationSemester",
        data() {
            return {
                path: "/timeTable/semester",
                loading: true,
                V4Judge: false,
                gradesInfo: {},
                semesters: {},
                semester_types:[],
                timeData: {},
                teachers: {},
                subjects: [],
                classes: [],
                class_student: {},
                currentUsers: {},
                class_types: {},
                type: 'semesterTable',
                crunkView: false,
                disableType: false,
                note: '',
                tempLength: 0,
                start_date:'',
                cell: {
                    selectable: false,
                    rect: [0, 0, 0, 0],
                    subject_id: '',
                    teacher_id: '',
                    template_time_id: '',
                    template_time_semester_id:'',
                    draggable: false,
                },
                teacherCell: {
                    selectable: false,
                    rect: [0, 1, 0, 0],
                    subject_id: '',
                    teacher_id: '',
                    template_time_id: '',
                    template_time_semester_id:'',
                    draggable: false,
                },
                filter: {
                    semester_type_id:'',
                    semester_id: this.$store.state.config.nowSemester.id,
                    grade_id: [],
                    section_id:this.$store.state.config.section.id,
                    date:''
                },
                showStudent: false,
                pluralClasses: {
                    viewJudge: false,
                    index: 0,
                    classes: [],
                    height: 50 * window.devicePixelRatio,
                },
                //学期
                scroll: {
                    left: 0,
                    top: 0
                },
                ops: {
                    rail: {
                        size: '3px',
                        gutterOfSide: '5px'
                    },
                    bar: {
                        keepShow: true,
                        background: 'rgba(144, 147, 153, 0.3)'
                    }
                },
                //dialogs
                classrooms: {},
                dialog_CreateClass_Semester: {
                    loading: false,
                    button_loading: false,
                    course: {},
                    courses: {},
                    search_loading: false,
                    classForm: {
                        name: '',
                        type: '',
                        classroom_id: '',
                        note: '',
                        subject_id: 0,
                        teacher_id: 0,
                        template_time_id: 0,
                        template_time_semester_id:'',
                        semester_id: 0,
                        class_type_id: 0,
                        grade_id: 0,
                        period: 0,
                        unit_period_price: 0,
                        start_date: '',
                        start_time:'',
                        nightClass: false,
                        duration:1.5,
                        unit_classHour:1,
                        sprintClass:false,
                    }
                },
                dialog_UpdateClass_Semester: {
                    loading: true,
                    button_loading: false,
                    search_loading: false,
                    classx: {},
                    classForm: {
                        name: '',
                        classroom_id: '',
                        note: '',
                        subject_id: 0,
                        teacher_id: 0,
                        template_time_id: 0,
                        template_time_semester_id:'',
                        semester_id: 2,
                        class_type_id: 0,
                        grade_id: 0,
                        period: 0,
                        unit_period_price: 0,
                        start_date: '',
                        nightClass: false,
                        sprintClass:false,
                        unit_classHour:0,
                        start_time:'',
                    },
                },
                dialog_CreateTeacher: {
                    teacher: {
                        name: '',
                        gender_id: 1,
                        birthday: '2000-01-01',
                        phone: '',
                        subject_id: '',
                        semester_id: '',
                        introducation:''
                    },
                    loading: true,
                    button_loading: false,
                },
                Dialog_GiveTeacherToSemester:{
                    filter:{
                        teacher_id:'',
                        subject_id:'',
                        semester_id:'',
                        section_id:''
                    },
                    teachers:[],
                    loading: true,
                    button_loading: false,
                },
                dialog_DeleteTeacher: {
                    loading: true,
                    button_loading: false,
                    insertForm: {
                        subject_id: '',
                        teacher_subject_id: '',
                    },
                },
                dialog_HideTeacher: {
                    loading: true,
                    button_loading: false,
                    insertForm: {
                        subject_id: '',
                        teacher_subject_id: '',
                    },
                },
                dialog_ActiveTeacher: {
                    loading: true,
                    button_loading: false,
                    insertForm: {
                        subject_id: '',
                        teacher_subject_id: '',
                    },
                    teachers: {},
                    temperTeachers: [],
                },
                timeTable: {
                    V4titleW: 100 * window.devicePixelRatio,
                    V4titleH: 50 * window.devicePixelRatio,
                    V4leftTimeW: 120 * window.devicePixelRatio,
                    V4rectW: 100 * window.devicePixelRatio,
                    V4rectH: 50 * window.devicePixelRatio,
                    V4ratio: window.devicePixelRatio,
                    V4divi: 2,
                },
                modalData:{

                },
                Dialog_ClassInformation:{
                    class_teacherVisits:{},
                    class_teacherVisit_content:'',
                    class_interactives:{},
                    class_notices:{},
                    class_notice_content:'',
                    class_assessments:{},
                    class_id:'',
                    loading:false,
                }
            }
        },
        components: {
            'V4Table': index
        },
        created() {
            this.$wApi.addListen(this.path, this.handleData);
            this.handleInit();
            this.handleShow();
            this.getAvailableClassrooms();
        },
        mounted() {

        },
        computed: {
            grades() {
                for (let i in this.gradesInfo) {
                    if (this.gradesInfo[i].name === '毕业') {
                        this.$delete(this.gradesInfo, this.gradesInfo[i].id);
                    }
                }
                return this.gradesInfo;
            },
            powers(){
                return this.$store.state.config.powers;
            }
        },

        methods: {
            handleData(event, data) {
                let vm = this;
                switch (event) {
                    case 'init':
                        this.class_types = data.class_types;
                        this.semesters = data.semesters;
                        this.semester_types = data.semester_types;
                        this.gradesInfo = data.grades;
                        break;
                    case 'show':
                        this.timeData = data.timeData;
                        this.teachers = data.teachers;
                        this.subjects = data.subjects;
                        this.classes = data.classes;
                        this.classrooms = data.classrooms;
                        this.class_student = data.class_student;
                        this.tempLength = data.tempLength;
                        this.start_date = data.start_date;
                        this.filter.section_id = data.section_id;
                        this.V4Judge = true;
                        this.loading = false;
                        break;
                    case 'floatBox':
                        if (data.type === 'teacher') {
                            this.floatBox.teacher = data.detail;
                            this.floatBox.viewJudge = true;
                        } else if (data.type === 'student') {
                            this.floatBox.student = data.detail;
                            this.floatBox.viewJudge = true;
                        }
                        break;
                    case 'get_class':
                        this.dialog_UpdateClass_Semester.classx = data.classx;
                        this.dialog_UpdateClass_Semester.classx.class_id = data.classx.id;
                        this.dialog_UpdateClass_Semester.classForm = {
                            name: this.dialog_UpdateClass_Semester.classx.name,
                            subject_id: this.dialog_UpdateClass_Semester.classx.subject_id,
                            teacher_id: this.dialog_UpdateClass_Semester.classx.teacher_id,
                            template_time_semester_id: this.dialog_UpdateClass_Semester.classx.template_time_semester_id,
                            semester_id: this.dialog_UpdateClass_Semester.classx.semester_id,
                            class_type_id: this.dialog_UpdateClass_Semester.classx.class_type_id,
                            classroom_id: this.dialog_UpdateClass_Semester.classx.classroom_id,
                            grade_id: this.dialog_UpdateClass_Semester.classx.grade.id,
                            period: this.dialog_UpdateClass_Semester.classx.period,
                            original_period: this.dialog_UpdateClass_Semester.classx.original_period,
                            unit_period_price: this.dialog_UpdateClass_Semester.classx.unit_period_price,
                            note: this.dialog_UpdateClass_Semester.classx.note,
                            type: this.dialog_UpdateClass_Semester.classx.type,
                            duration: this.dialog_UpdateClass_Semester.classx.duration,
                            unit_classHour: this.dialog_UpdateClass_Semester.classx.unit_classHour,
                            start_time: this.dialog_UpdateClass_Semester.classx.start_time
                        };
                        this.classrooms = data.classrooms;
                        this.dialog_UpdateClass_Semester.loading = false;
                        // this.handleIndexClassroom();
                        break;
                    case 'search_classroom':
                        this.classrooms = data.classrooms;
                        this.dialog_UpdateClass_Semester.search_loading = false;
                        this.dialog_CreateClass_Semester.search_loading = false;
                        break;
                    case 'update_class':
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.classes[this.cell.teacher_id][this.cell.template_time_id].forEach(function (item, index) {
                            if (item.class_id === data.updateInfo.class_id) {
                                vm.classes[vm.cell.teacher_id][vm.cell.template_time_id][index] = data.updateInfo;
                            }
                        });
                        this.$refs.V4Table.initCanvas();
                        this.$Win.closeModal();
                        this.dialog_UpdateClass_Semester.button_loading = false;
                        this.cell.selectable=false;
                        break;
                    case 'update_class_error':
                        this.dialog_UpdateClass_Semester.button_loading = false;
                        break;
                    case 'get_Crunk':
                        this.class_student = data.class_student;
                        // this.crunkView = !this.crunkView;
                        this.$refs.V4Table.initCanvas();
                        this.loading = false;
                        break;
                    case 'get_Crunk_error':
                        break;
                    case 'store_teacher':
                        this.$message({
                            message: '创建成功',
                            type: 'success'
                        });

                        if(data.teacher.semester_id==this.filter.semester_id){
                            if(!this.teachers[data.teacher.subject_id]){
                                this.teachers[data.teacher.subject_id]={};
                            }
                            this.$set(this.teachers[data.teacher.subject_id], data.teacher.teacher_id, data.teacher);
                            this.subjects = data.subjects;
                            this.tempLength = data.tempLength;
                            setTimeout(()=>{
                                this.$refs.V4Table.initCanvas();
                            },100)

                        }
                        this.dialog_CreateTeacher.button_loading = false;
                        this.$Win.closeModal();
                        break;
                    case 'get_teacher_notIn_semester':
                        this.Dialog_GiveTeacherToSemester.teachers = data.teachers;
                        break;
                    case 'search_teacher_notIn_semester':
                        this.Dialog_GiveTeacherToSemester.teachers = data.teachers;
                        break;
                    case 'give_teacher_to_semester':
                        this.$message({
                            message: '创建成功',
                            type: 'success'
                        });

                        if(data.teacher.semester_id==this.filter.semester_id){
                            if(!this.teachers[data.teacher.subject_id]){
                                this.teachers[data.teacher.subject_id]={};
                            }
                            this.$set(this.teachers[data.teacher.subject_id], data.teacher.teacher_id, data.teacher);
                            this.subjects = data.subjects;
                            this.tempLength = data.tempLength;
                            setTimeout(()=>{
                                this.$refs.V4Table.initCanvas();
                            },100)

                        }
                        this.Dialog_GiveTeacherToSemester.filter.subject_id='';
                        this.Dialog_GiveTeacherToSemester.filter.teacher_id='';
                        this.dialog_CreateTeacher.button_loading = false;
                        this.$Win.closeModal();
                        break;
                    case 'store_teacher_error':
                        this.dialog_CreateTeacher.button_loading = false;
                        break;
                    case 'remove_teacher_form_subject':
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        if(this.filter.semester_id==data.semester_id){
                            for (let i in this.teachers) {
                                for (let j in this.teachers[i]) {
                                    if (this.teachers[i][j].id === this.dialog_DeleteTeacher.insertForm.teacher_subject_id) {
                                        var subject_id=this.teachers[i][j].subject_id;
                                        this.$delete(this.teachers[subject_id], this.teachers[i][j].teacher_id);
                                        if(!this.teachers[subject_id]){
                                            this.$delete(this.teachers,subject_id);
                                        }
                                    }
                                }
                            }

                            this.subjects = data.subjects;
                            this.tempLength = data.tempLength;
                            setTimeout(()=>{
                                this.$refs.V4Table.initCanvas();
                            },100)

                        }

                        this.dialog_DeleteTeacher.button_loading = false;
                        this.$Win.closeModal();
                        break;
                    case 'remove_teacher_form_subject_error':
                        this.dialog_DeleteTeacher.button_loading = false;
                        break;
                    case 'change_teacher_status':
                        this.$message({
                            message: '切换成功',
                            type: 'success'
                        });
                        if(this.filter.semester_id==data.semester_id) {
                            if (data.type === 'active') {
                                this.$set(this.teachers[data.teacher.subject_id], data.teacher.teacher_id, data.teacher);
                            } else if (data.type === 'hide') {
                                for (let i in this.teachers) {
                                    for (let j in this.teachers[i]) {
                                        if (this.teachers[i][j].id === this.dialog_HideTeacher.insertForm.teacher_subject_id) {
                                            this.$delete(this.teachers[this.teachers[i][j].subject_id], this.teachers[i][j].teacher_id);
                                        }
                                    }
                                }
                            }
                            this.subjects = data.subjects;
                            this.tempLength = data.tempLength;
                            setTimeout(()=>{
                                this.$refs.V4Table.initCanvas();
                            },100)
                        }
                        this.dialog_HideTeacher.button_loading = false;
                        this.dialog_ActiveTeacher.button_loading = false;
                        this.$Win.closeModal();
                        break;
                    case 'change_teacher_status_error':
                        this.dialog_HideTeacher.button_loading = false;
                        this.dialog_ActiveTeacher.button_loading = false;
                        break;
                    case 'get_teachers':
                        this.dialog_ActiveTeacher.teachers = data.teachers;
                        for (let i in this.dialog_ActiveTeacher.teachers) {
                            for (let j in this.dialog_ActiveTeacher.teachers[i]) {
                                this.dialog_ActiveTeacher.temperTeachers.push(this.dialog_ActiveTeacher.teachers[i][j]);
                            }
                        }
                        this.dialog_ActiveTeacher.search_loading = false;
                        this.dialog_ActiveTeacher.loading = false;
                        break;
                    case 'get_teachers_error':
                        this.dialog_ActiveTeacher.search_loading = false;
                        this.dialog_ActiveTeacher.loading = false;
                        break;
                    case 'give_teacher_note':
                        this.$message({
                            message: '添加备注成功',
                            type: 'success'
                        });
                        if(this.filter.semester_id==data.semester_id) {
                            this.teachers[this.teacherCell.subject_id][this.teacherCell.teacher_id].note = this.note;
                            this.$refs.V4Table.initCanvas();
                        }
                        this.teacherCell.selectable=false;
                        break;
                    //创建课程
                    case 'store_class':
                        this.$message({
                            message: '创建成功',
                            type: 'success'
                        });
                        if(!this.classes[this.cell.teacher_id]){
                            this.$set(this.classes,this.cell.teacher_id,{});
                        }
                        this.$set(this.classes[this.cell.teacher_id], this.cell.template_time_id, [data.createInfo]);
                        this.$refs.V4Table.initCanvas();
                        this.dialog_CreateClass_Semester.button_loading = false;
                        this.$Win.closeModal();
                        this.cell.selectable=false;
                        // this.classForm.period = data.course.period;
                        break;
                    case 'store_class_error':
                        this.dialog_CreateClass_Semester.button_loading = false;
                        break;
                    case 'get_course':
                        if (data.type === 'create') {
                            this.dialog_CreateClass_Semester.courses = data.courses;
                            if (this.dialog_CreateClass_Semester.classForm.subject_id === 24) {
                                this.dialog_CreateClass_Semester.classForm.name = '晚托';
                                this.dialog_CreateClass_Semester.classForm.period = data.course_count;
                            } else {
                                this.dialog_CreateClass_Semester.course = data.course;
                                if(data.course){
                                    this.dialog_CreateClass_Semester.classForm.period = data.course.period;
                                }
                                this.dialog_CreateClass_Semester.classForm.name = this.grades[this.dialog_CreateClass_Semester.classForm.grade_id].name +
                                    this.subjects[this.cell.subject_id].name;
                            }
                        } else if (data.type === 'update') {
                            this.dialog_UpdateClass_Semester.courses = data.courses;
                            // this.dialog_UpdateClass_Semester.classForm.class_type_id = 0;
                            if (this.dialog_UpdateClass_Semester.classForm.subject_id === 24) {
                                this.dialog_UpdateClass_Semester.classForm.name = '晚托';
                            } else {
                                this.dialog_UpdateClass_Semester.course = data.course;
                                this.dialog_UpdateClass_Semester.classForm.period = data.course.period;
                                this.dialog_UpdateClass_Semester.classForm.name = this.grades[this.dialog_UpdateClass_Semester.classForm.grade_id].name +
                                    this.subjects[this.cell.subject_id].name;
                            }
                            // this.dialog_UpdateClass_Semester.classForm.class_type_id = 0;
                        }
                        break;
                    case 'get_course_error':
                        break;
                    //获取课程
                    case 'get_classrooms':
                        this.classrooms = data.classrooms;
                        break;
                    //修改课程
                    case 'delete_class':
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.classes[this.cell.teacher_id][this.cell.template_time_id].forEach(function (item, index) {
                            if (item.class_id === data.class_id) {
                                vm.classes[vm.cell.teacher_id][vm.cell.template_time_id].splice(index, 1);
                            }
                        });
                        if (this.classes[this.cell.teacher_id][this.cell.template_time_id].length === 0) {
                            this.$delete(this.classes[this.cell.teacher_id], this.cell.template_time_id);
                        }
                        this.$refs.V4Table.initCanvas();
                        this.dialog_UpdateClass_Semester.button_loading = false;
                        this.$Win.closeModal();
                        this.cell.selectable=false;
                        break;
                    case 'delete_class_error':
                        this.dialog_UpdateClass_Semester.button_loading = false;
                        break;
                    case 'cancel_class':
                        this.$message({
                            message: '取消成功',
                            type: 'success'
                        });
                        this.classes[this.cell.teacher_id][this.cell.template_time_id].forEach(function (item, index) {
                            if (item.class_id === data.class_id) {
                                vm.classes[vm.cell.teacher_id][vm.cell.template_time_id].splice(index, 1);
                            }
                        });
                        if (this.classes[this.cell.teacher_id][this.cell.template_time_id].length === 0) {
                            this.$delete(this.classes[this.cell.teacher_id], this.cell.template_time_id);
                        }
                        this.$refs.V4Table.initCanvas();
                        this.dialog_UpdateClass_Semester.button_loading = false;
                        this.$Win.closeModal();
                        this.cell.selectable=false;
                        break;
                    case 'cancel_class_error':
                        this.dialog_UpdateClass_Semester.button_loading = false;
                        break;
                    case 'finish_class':
                        this.$message({
                            message: '结课成功',
                            type: 'success'
                        });
                        this.classes[this.cell.teacher_id][this.cell.template_time_id].forEach(function (item, index) {
                            if (item.class_id === data.class_id) {
                                vm.classes[vm.cell.teacher_id][vm.cell.template_time_id].splice(index, 1);
                            }
                        });
                        if (this.classes[this.cell.teacher_id][this.cell.template_time_id].length === 0) {
                            this.$delete(this.classes[this.cell.teacher_id], this.cell.template_time_id);
                        }
                        this.$refs.V4Table.initCanvas();
                        this.dialog_UpdateClass_Semester.button_loading = false;
                        this.$Win.closeModal();
                        this.cell.selectable=false;
                        break;
                    case 'finish_class_error':
                        this.dialog_UpdateClass_Semester.button_loading = false;
                        break;
                    //交换课程
                    case 'drop_class':
                        this.$message({
                            message: '交换成功',
                            type: 'success'
                        });
                        this.$delete(this.classes[this.cell.teacher_id], this.cell.template_time_id);
                        if(!this.classes[data.dropInfo.teacher_id]){
                            this.classes[data.dropInfo.teacher_id]={};
                        }
                        this.$set(this.classes[data.dropInfo.teacher_id], data.dropInfo.template_time_id, [data.dropInfo]);
                        this.$refs.V4Table.initCanvas();
                        this.cell.selectable=false;
                        break;
                    case 'drop_class_error':
                        break;
                    case 'get_semesters_by_semester_type':
                        this.semesters=data.semesters;
                        if(data.semester_id){
                            this.filter.semester_id=data.semester_id;
                        }
                        this.handleShow();
                        break;
                    case 'get_classInformation':
                        if (Object.keys(data.class_teacherVisits).length !== 0) {
                            this.Dialog_ClassInformation.class_teacherVisits = data.class_teacherVisits
                        } else {
                            this.Dialog_ClassInformation.class_teacherVisits = new Object();
                        }

                        if (Object.keys(data.class_interactives).length !== 0) {
                            this.Dialog_ClassInformation.class_interactives = data.class_interactives
                        } else {
                            this.Dialog_ClassInformation.class_interactives = new Object();
                        }

                        if (Object.keys(data.class_notices).length !== 0) {
                            this.Dialog_ClassInformation.class_notices = data.class_notices
                        } else {
                            this.Dialog_ClassInformation.class_notices = new Object();
                        }

                        if (Object.keys(data.class_assessments).length !== 0) {
                            this.Dialog_ClassInformation.class_assessments = data.class_assessments
                        } else {
                            this.Dialog_ClassInformation.class_assessments = new Object();
                        }
                        this.Dialog_ClassInformation.loading=false
                        break;
                }
            },
            handleSemesters(){
                this.$wApi.send(this.path, 'get_semesters_by_semester_type',
                    {'semester_type_id': this.filter.semester_type_id});
            },
            handleInit(){
                this.$wApi.send(this.path, 'init', {});
            },
            handleShow() {
                this.loading = true;
                this.filter.grade_id=[];
                this.$wApi.send(this.path, 'show', {
                    'semester_id': this.filter.semester_id,
                    'end_date': this.filter.date,
                });
                this.cell.selectable = false;
                this.V4Judge = false;
            },
            changeGrade(){
                for(let subject_id in this.teachers){
                    for (let key in this.teachers[subject_id]) {
                        var teacherGrades=this.teachers[subject_id][key].grades
                        let union = teacherGrades.filter(v => this.filter.grade_id.includes(v))
                        if(union.length==0 && this.filter.grade_id.length>0){
                            this.teachers[subject_id][key].view=false;
                        }else{
                            this.teachers[subject_id][key].view=true;
                        }
                    }
                }
                var start=0;
                this.tempLength=0;
                for(let key1 in this.subjects){
                    let teacherView=0;
                    for (let teacher_id in this.teachers[key1]) {
                        if(this.teachers[key1][teacher_id].view){
                            teacherView+=1;
                        }
                    }
                    if(teacherView==0 &&  this.filter.grade_id.length==0){
                        teacherView=1;
                    }
                    this.subjects[key1].dataLength=teacherView
                    this.subjects[key1].rect=[this.tempLength+start*0.1,0,teacherView,1]
                    this.tempLength+=teacherView;
                    if(teacherView==0){
                        this.subjects[key1].view=false;
                    }else{
                        this.subjects[key1].view=true;
                        start=start+1;
                    }
                }
                setTimeout(()=>{
                    this.$refs.V4Table.initCanvas();
                },100)
            },
            //获取教室信息
            getAvailableClassrooms(student_num = 10) {
                this.$wApi.send(this.path, 'get_classrooms', {
                    'template_time_id': this.cell.template_time_id,
                    'semester_id': this.filter.semester_id,
                    'student_num': student_num,
                });
            },

            drop(evt) {
                if (this.powers.includes(50)) {
                    if (evt.next.subject_id !== this.cell.subject_id) {
                        this.cell.selectable = false;
                        return this.$message({
                            message: '学科不同',
                            type: 'error'
                        });
                    }
                    if (this.classes[evt.next.teacher_id] && this.classes[evt.next.teacher_id][evt.next.template_time_id] && evt.next.subject_id !== 24) {
                        this.cell.selectable = false;
                        return this.$message({
                            message: '不能重叠',
                            type: 'error'
                        });
                    }

                    if(this.classes[evt.origin.teacher_id][evt.origin.template_time_id][0].semester_id!=this.filter.semester_id){
                        return this.$message({
                            message: '学期不同，不能调换',
                            type: 'warning'
                        });
                    }

                    this.$confirm('确认调换?', '提示', {
                        StartReturn: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$wApi.send(this.path, 'drop_class', {
                            'class_id': this.classes[evt.origin.teacher_id][evt.origin.template_time_id][0].class_id,
                            'teacher_id': evt.next.teacher_id,
                            'class_type_id': this.classes[evt.origin.teacher_id][evt.origin.template_time_id][0].class_type_id,
                            'template_time_semester_id': evt.next.template_time_semester_id,
                            'semester_id': this.filter.semester_id
                        });
                    }).catch(() => {
                        this.cell.selectable = false;
                        this.$message({
                            type: 'info',
                            message: '已取消'
                        });
                    });
                } else {
                    this.cell.selectable = false;
                    return this.$message.error("无权操作");
                }
            },
            allowDrop(event) {
                event.preventDefault();
                return true;
            },
            //老师调换位置
            showStudentFuc() {
                this.loading = true;
                // this.V4Judge = false;
                this.disableType = !this.disableType;
                // this.showStudent = !this.showStudent;
                this.timeTable.V4rectH = (this.showStudent ? 200 : 50) * window.devicePixelRatio;
                this.timeTable.V4divi = this.showStudent ? 8 : 2;
                this.$nextTick(function () {
                    this.$refs.V4Table.initCanvas()
                });
                this.loading = false;
                // this.V4Judge = true;
            },
            handleViewCrunk() {
                this.loading = true;
                this.type = 'timeTable';
                this.$wApi.send(this.path, 'get_Crunk', {
                    'semester_id': this.filter.semester_id,
                    'hasPeriod': !this.crunkView,
                });
            },
            handleTableSite() {
                let clickJudge=true;
                if(this.filter.section_id==4){
                    if(!this.powers.includes(144)){
                        clickJudge=false;
                    }
                }
                if(clickJudge){
                    this.$Win.openModal('Dialog_TableSiteModal', 441, 100, '课表设置', {
                        'semester_id': this.filter.semester_id,
                        'teachers': JSON.stringify(this.teachers)
                    });
                }else{
                    this.$message({
                        type: 'warning',
                        message: '无权操作'
                    });
                }

            },
            handleExcel() {
                // this.$Win.openModal('Dialog_TimeTableExcel', 341, 100, '导出excel', {
                //     'semester_id': this.filter.semester_id,
                // });
                window.open('http://server.modijiaoyu.com'+'/timeTableExcel?semester_id='+this.filter.semester_id);
            },

            //点击老师头部文字
            handleTeacherMouseDown() {
                if (this.teacherCell.clickTable && this.teacherCell.teacher_id!=0) {
                    return this.$prompt(this.teachers[this.teacherCell.subject_id][this.teacherCell.teacher_id].name + '的备注', '', {
                        inputValue: this.teachers[this.teacherCell.subject_id][this.teacherCell.teacher_id].note,
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                    }).then(({value}) => {
                        this.note = value;
                        this.$wApi.send(this.path, 'give_teacher_note', {
                            'teacher_id': this.teacherCell.teacher_id,
                            'semester_id': this.filter.semester_id,
                            'note': value,
                        });
                    })
                }
            },
            handleClickTeacher(x, y) {
                const px = Math.floor(x / this.timeTable.V4rectW);
                const py = Math.floor(y / this.timeTable.V4titleH);

                let subject_id = 0;
                for (let key in this.subjects) {
                    if (this.subjects[key].rect[0] * this.timeTable.V4rectW < x && x < (this.subjects[key].rect[2] + this.subjects[key].rect[0]) * this.timeTable.V4rectW) {
                        subject_id = key;
                        break;
                    }
                }

                let teacherCell = {
                    selectable: false,
                    type: 'class',
                    rect: [px, py, 1, 1],
                    clickTable: false,
                    subject_id: '',
                    teacher_id: '',
                };

                teacherCell.subject_id = subject_id;

                let subject = this.subjects[teacherCell.subject_id];

                let teachers = this._.orderBy(this.teachers[subject_id], 'sortBy', 'asc');
                let j = 0;
                for (const key in teachers) {
                    if ((subject.rect[0] + j) * this.timeTable.V4rectW < x && x < (subject.rect[0] + j + 1) * this.timeTable.V4rectW) {
                        teacherCell.rect[0] = subject.rect[0] + j;
                        teacherCell.teacher_id = teachers[key].teacher_id;
                        teacherCell.clickTable = true;
                        break;
                    }
                    j++;
                }

                this.teacherCell.selectable = false;


                if (py === 1) {
                    this.boxTop = this.timeTable.V4titleH + this.scrollTop;
                    teacherCell.selectable = true;
                    teacherCell.draggable = false;
                    teacherCell.type = 'teacher';
                    this.teacherCell = teacherCell;
                    return 0;
                } else {
                    this.teacherCell.selectable = false;
                    return 0;
                }
            },

            //在课表中的点击
            handleMousedown(evt) {
                let x = evt.x;
                let y = evt.y;
                if (this.cell.clickTable) {
                    if (this.classes[this.cell.teacher_id] && this.classes[this.cell.teacher_id][this.cell.template_time_id]) {
                        if (this.classes[this.cell.teacher_id][this.cell.template_time_id].length >= 2) {
                            this.pluralClasses.viewJudge = true;
                            this.pluralClasses.index = 0;
                            this.pluralClasses.classes = this.classes[this.cell.teacher_id][this.cell.template_time_id];
                        } else {
                            this.cell.classx = this.classes[this.cell.teacher_id][this.cell.template_time_id][0];
                            if(this.cell.classx.semester_id!=this.filter.semester_id){
                                return this.$message({
                                    message: '学期不同',
                                    type: 'warning'
                                });
                            }else{
                                const offsetY = y - (Math.floor(y / this.timeTable.V4rectH)) * this.timeTable.V4rectH;
                                if (offsetY <= 50) {
                                    let clickJudge=true;
                                    if(this.filter.section_id==4){
                                        if(!this.powers.includes(144)){
                                            clickJudge=false;
                                        }
                                    }
                                    if(clickJudge){
                                        this.$Win.openModal('Dialog_UpdateClass_Semester', 650, 700, '修改课程', {
                                            "subject": this.subjects[evt.data.subject_id],
                                            "teacher": this.teachers[evt.data.subject_id][evt.data.teacher_id],
                                            "timeData": this._.find(this.timeData, ['id', evt.data.template_time_id]),
                                            "semester": this.semesters[this.filter.semester_id],
                                            "class": this.classes[evt.data.teacher_id][evt.data.template_time_id][0]
                                        });
                                    }
                                } else {
                                    if (this.powers.includes(2)) {
                                        let px = (Math.floor(x / 50) / 2 === 0) ? 0 : 1;
                                        let py = Math.floor(y / (this.timeTable.V4rectH / this.timeTable.V4ratio / this.timeTable.V4divi));
                                        let t = 0;
                                        if (px === 0) {
                                            t = (py - 2) * 2
                                        } else {
                                            t = (py - 2) * 2 + 1
                                        }

                                        this.studentCell = {
                                            rect: [px, py, 1, 1]
                                        };

                                        let rect = [px, py, 1, 1];
                                        for (const student_id in this.class_student[this.cell.classx.class_id]) {
                                            let student_rect = this.class_student[this.cell.classx.class_id][student_id].rect;
                                            if (rect.sort().toString() === student_rect.sort().toString()) {
                                                let student = this.class_student[this.cell.classx.class_id][student_id];
                                                this.$confirm('确认进入学生' + student.student_name + '详情?', '提示', {
                                                    StartReturn: '确定',
                                                    cancelButtonText: '取消',
                                                    type: 'warning'
                                                }).then(() => {
                                                    this.$store.dispatch('addView', {
                                                        'title': student.student_name,
                                                        'path': '/student/' + student.student_id,
                                                        'closable': true
                                                    });
                                                    this.router.push({path: '/student/' + student.student_id})
                                                }).catch(() => {
                                                    this.$message({
                                                        type: 'info',
                                                        message: '已取消'
                                                    });
                                                });
                                            }
                                        }
                                    }
                                    this.cell.draggable = false
                                }
                            }
                        }
                    } else {
                        let clickJudge=false;
                        if(this.filter.section_id==4){
                            if(this.powers.includes(144)){
                                clickJudge=true;
                            }
                        }else{
                            if (this.powers.includes(49)) {
                                clickJudge=true;
                            }
                        }
                        if (clickJudge) {
                            if(evt.data.teacher_id!=0){
                                this.modalData = {
                                    subject: this.subjects[evt.data.subject_id],
                                    teacher: this.teachers[evt.data.subject_id][evt.data.teacher_id],
                                    timeData: this._.find(this.timeData, ['id', evt.data.template_time_id]),
                                    semester: this.semesters[this.filter.semester_id],
                                    start_date: this.start_date,
                                };

                                this.$Win.openModal('Dialog_CreateClass_Semester', 650, 700, '创建课程', {
                                    "subject": this.subjects[evt.data.subject_id],
                                    "teacher": this.teachers[evt.data.subject_id][evt.data.teacher_id],
                                    "timeData": this._.find(this.timeData, ['id', evt.data.template_time_id]),
                                    "semester": this.semesters[this.filter.semester_id]
                                });
                            }
                        }
                    }
                } else {
                    if (this.cell.rect[1] === -1) {
                        if (Math.floor(((y) * this.timeTable.V4ratio - this.timeTable.V4titleH) / this.timeTable.V4rectH) < 0) {
                            const y = y * this.ratio - this.timeTable.V4titleH * 2;
                            let teacher = this.teachers[this.cell.subject_id][this.cell.teacher_id];
                            return this.$prompt(teacher.name + '的备注', '', {
                                inputValue: teacher.note,
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                            }).then(({value}) => {
                                // this.$axios.put(store.state.server + '/termTimeTable/teacher/' + teacher.teacher_id + '?semester_id=' + this.semester_id + '&' + localStorage.baseUrl, {
                                //     note: value
                                // }).then(response => {
                                //
                                // })
                            })
                        } else {
                            const y = $event.offsetY * this.ratio - this.titleH + this.scrollTop;
                            const py = Math.floor(y / this.timeTable.V4rectH);
                            this.cell.clickTable = true;
                            this.cell.rect[1] = py;
                            this.cell.template_time_id = this.timeData[py + 1].id;
                            if (this.cell.rect[1] * this.timeTable.V4rectH + this.timeTable.V4titleH - this.scrollTop < 0) {
                                this.cell.selectable = false;
                            }
                            if (this.cell.rect[0] * this.timeTable.V4rectW / this.timeTable.V4ratio + -this.scrollLeft < 0) {
                                this.cell.selectable = false;
                            }
                            if (this.classes[this.cell.teacher_id] && this.classes[this.cell.teacher_id][this.cell.template_time_id]) {
                                this.cell.draggable = true;
                            }
                            this.boxTop = (this.cell.rect[1] * this.timeTable.V4rectH);
                        }

                    }
                }
            },
            handleClickTimeTable(x, y) {
                const px = Math.floor(x / this.timeTable.V4rectW);
                const py = Math.floor(y / this.timeTable.V4rectH);

                let subject_id = 0;
                for (let key in this.subjects) {
                    if (this.subjects[key].rect[0] * this.timeTable.V4rectW < x && x < (this.subjects[key].rect[2] + this.subjects[key].rect[0]) * this.timeTable.V4rectW) {
                        subject_id = key;
                        break;
                    }
                }

                let cell = {
                    selectable: false,
                    type: 'class',
                    rect: [px, py, 1, 1],
                    clickTable: false,
                    subject_id: '',
                    teacher_id: '',
                };

                cell.subject_id = subject_id;

                let subject = this.subjects[cell.subject_id];

                let teachers = this._.orderBy(this.teachers[subject_id], 'sortBy', 'asc');
                let j = 0;
                for (const key in teachers) {
                    if ((subject.rect[0] + j) * this.timeTable.V4rectW < x && x < (subject.rect[0] + j + 1) * this.timeTable.V4rectW) {
                        cell.rect[0] = subject.rect[0] + j;
                        cell.teacher_id = teachers[key].teacher_id;
                        break;
                    }
                    j++;
                }

                this.cell.selectable = false;


                if (cell.rect[1] * this.timeTable.V4rectH + this.timeTable.V4titleH < 0) {
                    return 0;
                }


                if (!cell.teacher_id)
                    return 0;

                cell.selectable = true;
                cell.clickTable = true;
                cell.template_time_id = this.timeData[py + 1].id;

                if (this.classes[cell.teacher_id] && this.classes[cell.teacher_id][cell.template_time_id]) {
                    cell.draggable = true;
                }
                this.cell = cell;
            },
        }
    }
</script>

<style scoped lang="scss">
    .left {
        float: left;
        width: 800px;
        padding-top: 10px;
    }

    .right {
        margin-left: 810px;
        padding-top: 10px;
    }
</style>
